import React, { useEffect } from 'react';
import { htcmdService } from 'js/services/htcmd.service';

import { ReceivePacketCallback } from '../../../types';
import { useInitXpointNativeSDK } from './useInitXpointNativeSDK';
import { useOnXpointError } from './useOnXpointError';
import { useXpointGeofencingHandler } from './useXpointGeofencingHandler';
import { useRequestXpointNativePacket } from './useRequestXpointNativePacket';

import * as Types from '../types';

export const useXpointNativeIntegration = ({
    sdk,
    enable,
    license,
    transactionID,
    useTransparentPopup,
    onConnect,
    setShowOverlay,
    receivePacket,
    triggerGeolocation
}: {
    sdk: Types.XPointSDKInstance | null;
    enable: boolean;
    license: any;
    transactionID: string | null;
    useTransparentPopup: boolean;
    onConnect: CallableFunction;
    setShowOverlay: React.Dispatch<React.SetStateAction<boolean>>;
    receivePacket: ReceivePacketCallback;
    triggerGeolocation: Types.TriggerGeolocationCallback;
}) => {
    const initXpointNativeSDK = useInitXpointNativeSDK();
    const onError = useOnXpointError({ transactionID, setShowOverlay, useTransparentPopup });
    const requestXpointNativePacket = useRequestXpointNativePacket({
        sdk,
        license,
        transactionID,
        onError
    });

    useXpointGeofencingHandler({
        triggerGeolocation,
        onConnect,
        receivePacket,
        onError
    });

    useEffect(() => {
        if (!enable || !sdk) {
            return;
        }

        htcmdService.sendMessage('geofencingsupported');
    }, [sdk, enable, onConnect]);

    return { requestXpointNativePacket, initXpointNativeSDK };
};
